export default __webpack_public_path__ + "static/media/tc.72d02197.svg";